import {ContentPartnerStatus, ContentPartnerStatusName} from './ContentPartnersTypes';

export const renderStatus = ({active}: ContentPartnerStatus): string => {
    if (active) {
        return ContentPartnerStatusName.Active;
    }
    return ContentPartnerStatusName.InActive;
};

export default [
    {
        dataKey: 'partnerName',
        title: 'Partner Name',
        sortable: true,
    },
    {
        dataKey: 'cmsPartnerId',
        title: 'Partner ID',
    },
    {
        dataKey: 'active',
        title: 'Status',
        render: renderStatus,
    },
    {
        dataKey: 'createdAt',
        title: 'Created',
        sortable: true,
    },
    {
        dataKey: 'updatedAt',
        title: 'Updated',
        sortable: true,
    },
];
